import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
import { makeModal } from './makeModal';
export var pushModal = createAction(actionPrefix + ".PUSH_MODAL", makeModal);
export var popModal = createAction(actionPrefix + ".POP_MODAL", function () { return ({}); });
export var removeModalsOfType = createAction(actionPrefix + ".REMOVE_MODAL_TYPE", function (type) { return type; });
export var removeModal = createAction(actionPrefix + ".REMOVE_MODAL", function (id) { return id; });
//# sourceMappingURL=basicActions.js.map